// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ArrowToggle_arrow__PZZ5N","opened":"ArrowToggle_opened__RMn6V"};